import styled, { keyframes } from 'styled-components';
import { Space } from 'antd';
import { PrimaryButton, RichTextEditor, SecondaryButton } from '@lib/common';
import { RequestStatus } from '@module/form';
import { useEffect, useRef } from 'react';
import { EssayAnswerMetrics } from './essay-answer-metrics.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var answerEditorEnter = keyframes(["from{opacity:0;transform:translateY(6px);}to{opacity:1;transform:translateY(0);}"]);
var StyledAnswerEditor = styled.div.withConfig({
  displayName: "essay-answer-editor-editcomponent__StyledAnswerEditor",
  componentId: "sc-6tra1x-0"
})(["animation:", " 180ms ease-out;.ProseMirror{height:350px;min-height:350px;max-height:350px;overflow-y:auto;}@media (prefers-reduced-motion:reduce){animation:none;}"], answerEditorEnter);
var StyledAnswerHeader = styled.div.withConfig({
  displayName: "essay-answer-editor-editcomponent__StyledAnswerHeader",
  componentId: "sc-6tra1x-1"
})(["color:#1c1e20;font-size:14px;font-weight:700;line-height:20px;margin-bottom:16px;"]);
var StyledAnswerFooter = styled.div.withConfig({
  displayName: "essay-answer-editor-editcomponent__StyledAnswerFooter",
  componentId: "sc-6tra1x-2"
})(["display:flex;align-items:center;justify-content:space-between;gap:16px;margin-top:16px;"]);
export var EssayAnswerEditorEditComponent = function EssayAnswerEditorEditComponent(_ref) {
  var questionIndex = _ref.questionIndex,
      value = _ref.value,
      onChange = _ref.onChange,
      onShowingUploadModal = _ref.onShowingUploadModal,
      onShowingAudioUploadModal = _ref.onShowingAudioUploadModal,
      updateAnswerStatus = _ref.updateAnswerStatus,
      disabledSaveButtonStatus = _ref.disabledSaveButtonStatus,
      onUpdateAnswer = _ref.onUpdateAnswer,
      onChangePreviewMode = _ref.onChangePreviewMode,
      onDeleteDraftAnswer = _ref.onDeleteDraftAnswer,
      file = _ref.file,
      updateFileAnswerStatus = _ref.updateFileAnswerStatus,
      editorLabels = _ref.editorLabels,
      label = _ref.label,
      disabledCancelButtonStatus = _ref.disabledCancelButtonStatus;
  var editorRef = useRef(null);
  var essayAnswerEditorEditId = "submission-question-".concat(questionIndex);
  useEffect(function () {
    if (updateFileAnswerStatus === RequestStatus.SUCCESS && editorRef.current && file) {
      editorRef.current.insertImageHandler(file.url);
    }
  }, [file, updateFileAnswerStatus, essayAnswerEditorEditId]);

  var editor = /*#__PURE__*/_jsx(RichTextEditor, {
    ref: editorRef,
    id: essayAnswerEditorEditId,
    content: value,
    onChange: onChange,
    addImage: onShowingUploadModal,
    addAudio: onShowingAudioUploadModal,
    editorLabels: editorLabels,
    placeholder: label.inputAnswer,
    scrollable: true
  });

  var cancelButton = /*#__PURE__*/_jsx(SecondaryButton, {
    disabled: disabledCancelButtonStatus,
    onClick: function onClick() {
      onDeleteDraftAnswer();
      onChangePreviewMode();
    },
    children: label.cancel
  });

  var saveButton = /*#__PURE__*/_jsx(PrimaryButton, {
    size: "middle",
    disabled: disabledSaveButtonStatus,
    onClick: function onClick() {
      onDeleteDraftAnswer();
      onUpdateAnswer();
    },
    loading: updateAnswerStatus === RequestStatus.EXECUTE,
    children: label.save
  });

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(StyledAnswerHeader, {
      children: label.yourAnswer || 'Your Answer'
    }), /*#__PURE__*/_jsx(StyledAnswerEditor, {
      children: editor
    }), /*#__PURE__*/_jsxs(StyledAnswerFooter, {
      children: [/*#__PURE__*/_jsx(EssayAnswerMetrics, {
        value: value,
        label: label
      }), /*#__PURE__*/_jsxs(Space, {
        children: [cancelButton, saveButton]
      })]
    })]
  });
};